import { create } from 'zustand';

const useCssStore = create((set) => ({
    fontFamily: 'CookieRun-Regular',
    fontUrl: `url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2001@1.1/CookieRun-Regular.woff') format('woff')`,
    
    // 💡 1. 굵기 상태 저장용 변수 추가
    fontWeight: 400,
    availableWeights: [], 

    fontSize: 28,
    fontBold: false,
    lineHeight: 36,
    fontEffect: 'none',
    fontEffectColor: { r: 0, g: 0, b: 0, a: 1 },
    shadowX: 2,
    shadowY: 2,
    shadowBlur: 4,
    boxEffect: 'none',
    boxBorder: 1,
    boxEffectColor: { r: 0, g: 0, b: 0, a: 1 },
    boxShadowX: 2,
    boxShadowY: 2,
    boxShadowBlur: 4,
    chatBgColor: { r: 0, g: 0, b: 0, a: 0.5 },
    chatTextColor: { r: 255, g: 255, b: 255, a: 1 },
    bodyBgColor: { r: 255, g: 255, b: 255, a: 0 },
    enableFadeOut: false,
    fadeDuration: 30,
    chatMarginBottom: 5,
    showBadge: true,
    userIconSize: 32,
    badgeTop: 0, // 💡 뱃지 상하 위치 추가
    stickerSize: 48,
    stickerTop: 0, // 💡 이모티콘 상하 위치 추가
    showNotice: false,
    noticeText: '방송 공지가 들어갑니다.',
    noticeFontSize: 28,
    noticeBgColor: { r: 0, g: 0, b: 0, a: 0.5 },
    noticeHeight: 64,
    chatRadius: 12,
    noticeRadius: 12,
    showNickname: true,
    blockNickname: false,
    nicknameSuffixType: '', 
    nicknameSuffixCustom: '',
    nicknameSuffixColor: { r: 255, g: 255, b: 255, a: 1 },
    viewerNickname: '시청자별명',
    letterSpacing: 0,
    noticeTextColor: { r: 255, g: 255, b: 255, a: 1 },
    paddingTopBottom: 8,
    paddingLeftRight: 13,
    previewScale: 1,
    nameBgColor: { r: 255, g: 255, b: 255, a: 0 },
    nameColor: { r: 255, g: 255, b: 255, a: 1 },
    nameColorCheck: false,
    align: 'left',

    applyPreset: (preset) => set(() => ({ ...preset })),
    setAlign: (v) => set({ align: v }),
    setNameBgColor: (v) => set({ nameBgColor: v }),
    setNameColor: (v) => set({ nameColor: v }),
    setNameColorCheck: (v) => set({ nameColorCheck: v }),
    setPreviewScale: (v) => set({ previewScale: v }),
    
    // 💡 2. 폰트를 바꿀 때 굵기 배열(weights)도 같이 넘겨받도록 수정
    setFontFamily: (name, url, weights, defaultWeight) => set({
        fontFamily: name,
        fontUrl: url,
        availableWeights: weights || [],
        fontWeight: defaultWeight || 400
    }),
    
    // 💡 3. 굵기 변경용 함수 추가
    setFontWeight: (weight, url) => set({ fontWeight: weight, fontUrl: url }),

    setLetterSpacing: (v) => set({ letterSpacing: v }),
    setViewerNickname: (v) => set({ viewerNickname: v }),
    setFontSize: (v) => set({ fontSize: v }),
    setFontBold: (v) => set({ fontBold: v }),
    setLineHeight: (v) => set({ lineHeight: v }),
    setFontEffect: (v) => set({ fontEffect: v }),
    setFontEffectColor: (v) => set({ fontEffectColor: v }),
    setShadowX: (v) => set({ shadowX: v }),
    setShadowY: (v) => set({ shadowY: v }),
    setShadowBlur: (v) => set({ shadowBlur: v }),
    setBoxEffect: (v) => set({ boxEffect: v }),
    setBoxBorder: (v) => set({ boxBorder: v }),
    setBoxEffectColor: (v) => set({ boxEffectColor: v }),
    setBoxShadowX: (v) => set({ boxShadowX: v }),
    setBoxShadowY: (v) => set({ boxShadowY: v }),
    setBoxShadowBlur: (v) => set({ boxShadowBlur: v }),
    setChatBgColor: (v) => set({ chatBgColor: v }),
    setChatTextColor: (v) => set({ chatTextColor: v }),
    setBodyBgColor: (v) => set({ bodyBgColor: v }),
    setEnableFadeOut: (v) => set({ enableFadeOut: v }),
    setFadeDuration: (v) => set({ fadeDuration: v }),
    setChatMarginBottom: (v) => set({ chatMarginBottom: v }),
    setUserIconSize: (v) => set({ userIconSize: v }),
    setShowBadge: (v) => set({ showBadge: v }),
    setBadgeTop: (v) => set({ badgeTop: v }), // 💡 뱃지 위치 변경 함수
    setStickerSize: (v) => set({ stickerSize: v }),
    setStickerTop: (v) => set({ stickerTop: v }), // 💡 이모티콘 위치 변경 함수
    setShowNotice: (v) => set({ showNotice: v }),
    setNoticeText: (v) => set({ noticeText: v }),
    setNoticeFontSize: (v) => set({ noticeFontSize: v }),
    setNoticeBgColor: (v) => set({ noticeBgColor: v }),
    setNoticeHeight: (v) => set({ noticeHeight: v }),
    setChatRadius: (v) => set({ chatRadius: v }),
    setNoticeRadius: (v) => set({ noticeRadius: v }),
    setShowNickname: (v) => set({ showNickname: v }),
    setBlockNickname: (v) => set({ blockNickname: v }),
    setNicknameSuffixType: (v) => set({ nicknameSuffixType: v }),
    setNicknameSuffixCustom: (v) => set({ nicknameSuffixCustom: v }),
    setNicknameSuffixColor: (v) => set({ nicknameSuffixColor: v }),
    setNoticeTextColor: (v) => set({ noticeTextColor: v }),
    setPaddingTopBottom: (v) => set({ paddingTopBottom: v }),
    setPaddingLeftRight: (v) => set({ paddingLeftRight: v }),
}));

export default useCssStore;